<template>
<div>
<div class="page">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="left">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{this.$route.name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="right">
            <input type="text"  class="search" placeholder="请输入关键字"  v-model="input" @input="inputlist()">
            <img src="../../assets/img/search.png" class="searchImg" alt="搜索" >
            <div class="searchlist" v-if="searchliststatus">
                <ul>
                  <li style="color:rgba(0, 103, 255, 1)">指标：</li>
                  <li  v-for="(item,index) in searchlistzb"
                        :key="index"
                        @click="searchcheck(item,index)"
                    >
                      {{item.resName}}
                    </li>
                    <li style="color:rgba(0, 103, 255, 1)">文章：</li>
                  <li  v-for="(item,index) in searchlistwz"
                        :key="index"
                        @click="wzlistcheck(item)"
                    >
                      {{item.resName}}
                    </li>
                </ul>
             </div>
        </div>
      </div>
      <div class="info-content">
          <div class="left-list">
              <div class="left-title"><span>文献资料</span></div>
              <div class="left-content">
                  <ul>
                      <li  v-for="(item,index) in newstype"
                        :key="index"
                        :class="{active : current==index}"
                        @click="typecheck(item,index)"
                        >
                        <i :class="['iconfont', iconstyle[index]]"></i>
                        {{item.name}}
                        </li>
                  </ul>
              </div>
          </div>
          <div class="right-list">
              <div class="typename">文献资料 / {{typename}} </div>
              <ul>
                  <li  v-for="(item,index) in newslist"
                        :key="index"
                        >
                        <a @click="listcheck(item,index)">{{item.title}}</a>
                        <span>{{item.startDate}}</span>
                 </li>
                 <div class="num-style">
                     <span v-for="(item,index) in num"
                        :key="index"
                        @click="numcheck(itemtype,index+1)">
                        {{index+1}}</span>
                 </div>
              </ul>
          </div>
      </div>
  </div>  
  <div class="info-foot">
    <span>郴州市统计局</span>
    <span>技术支持：浙江鸿程计算机系统有限公司</span>
  </div>
  </div>
</template>

<script>
import {getnewtype,getnewlist} from '@/api/info.js'
import {searchdata} from '@/api/index.js'
export default {
  data(){
      return{
        newstype:'',
        newslist:'',
        current:'0',
        itemtype:'',
        num:[],
        input:'',
        typename:'',
        searchlistzb:'',
        searchlistwz:'',
        iconstyle:['icon-jiaoyu2','icon-jiaoyu1','icon-jiaoyu3'],
        searchliststatus:false,
        searchliststatusnone:false,
      }
  },
  mounted(){
      this.getnewtype()
  },
  methods:{
      searchcheck(item,index){
        this.$store.commit('getindicatordata',item)
        this.$router.push({ path:'/dataQuery',query:{type:2}});
    },
      inputlist(){
           if(this.input==''){
                this.searchliststatus=false
            }
            else{
                this.searchliststatus=true
                searchdata({resourceName:this.input,resourceType:'1'})
                .then(res=>{
                    
                    this.searchlistzb=res.data.data
                })
                searchdata({resourceName:this.input,resourceType:'2'})
                .then(res=>{
                
                    this.searchlistwz=res.data.data
                })
            }
        },
        wzlistcheck(item){
           this.$router.push({ path:'/article',query:{id:item.resoruceId,}}); 
        },
      listcheck(item,index){
           this.$router.push({ path:'/article',query:{id:item.id,}}); 
      },
      getnewtype(){
          getnewtype({dictionaryDm:'newsType'})
          .then(res=>{
              this.newstype=res.data.data
              this.typename=this.newstype[0].name
              this.itemtype=this.newstype[0].type
              getnewlist({itemDm:'wzlb',type:this.newstype[0].type,page:'1',pagesize:'10'})
              .then(res=>{
                  this.num=[],
                  this.newslist=res.data.data.list
                  for(var i=1;i<res.data.data.totalNum/10+1;i++){
                      this.num.push(i)
                  }
                  console.log(this.num)
              })

              
          })
      },
      typecheck(item,index){
          this.typename=item.name
          this.itemtype=item.type
          this.current=index
          getnewlist({itemDm:'wzlb',type:item.type,page:'1',pagesize:'10'})
              .then(res=>{
                  this.num=[],
                  this.newslist=res.data.data.list
                  //this.num = res.data.data.totalNum/10+1
                  for(var i=1;i<res.data.data.totalNum/10+1;i++){
                      this.num.push(i)
                  }
              })
      },
      numcheck(itemtype,num){
          getnewlist({itemDm:'wzlb',articleType:itemtype,page:num,rows:'10'})
              .then(res=>{
                  this.newslist=res.data.data.list
              })
      },
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/public.scss';
    .info-content{
            clear: both;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            .left-list{
                width: 200px;
                height: 620px;
                margin-right: 20px;
                background-color: #fff;
                .left-title{
                    width: 100%;
                    height: 40px;
                    font-size: 14px;
                    text-align: center;
                    line-height: 40px;
                    font-weight: bold;
                    span{
                        height: 38px;
                        border-bottom:2px solid #0067FF; 
                        display: inline-block;
                    }
                }
                .left-content{
                    height: 570px;
                    width: 200px;
                    ul{
                        margin: 0;
                        padding: 0;
                        li{
                            width: 200px;
                            height: 40px;
                            font-size: 13px;
                            line-height: 40px;
                            text-align: center;
                            cursor: pointer;
                        }
                        li:hover{
                            background-color:#c0d9f2; 
                        }
                        .active{
                                font-weight: bold;
                                color: #409EFF;
                        }
                    }
                }
            }
            .right-list{
                width: 780px;
                height: 620px;
                background-color: #fff;
                .typename{
                    width: 760px;
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    display: inline-block;
                    font-size: 14px;
                    /* float: left; */
                }
                ul{
                    margin: 0 20px;
                    margin-top: 10px;
                    padding: 0;
                    li{
                        height: 50px;
                        line-height: 50px;
                        font-size: 14px;
                        border-bottom: 1px dashed #ccc;
                        a{
                            height: 23px;
                            line-height: 23px;
                            float: left;
                            border-bottom: 1px solid #fff;
                            font-size: 14px;
                            cursor: pointer;
                            margin-top: 5px;
                            font-weight:bold;
                        }
                        span{
                            width: 100%;
                            height: 23px;
                            line-height: 23px;
                            float: left;
                            font-size: 12px;
                            color: #B9B9B9;
                            font-size: 12px;
                        }
                        a:hover{
                            border-bottom: 1px solid #ccc;
                        }
                    }
                }
                .num-style{
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    text-align: right;
                    margin-top: 10px;
                    
                    span{
                            width: 30px;
                            height: 30px;
                            background-color:#129ace;
                            display: inline-block;
                            text-align: center;
                            line-height: 30px;
                            font-size: 14px;
                            color: #fff;
                            cursor: pointer;
                            border-radius: 3px;
                    }
                }
            }
    }
    .info-foot{
      width: 100%;
      height: 140px;
      background: linear-gradient(360deg,rgba(37,122,214,1) 0%,rgba(93,175,244,1) 100%);
      margin-top: 50px;
      span:nth-child(1){
          margin-top: 35px;
      }
      span{
        height: 35px;
        width: 100%;
        text-align: center;
        line-height: 35px;
        font-size: 14px;
        float: left;
        color: #fff;
      }
    }
</style>


// WEBPACK FOOTER //
// src/pages/statisticalInfo/statisticalInfo.vue